export default "__VITE_ASSET__CZ5a_kqv__"